import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import {
    VApp,
    VBtn,
    VCard,
    VCardActions,
    VCardText,
    VCheckbox,
    VCol,
    VContainer,
    VDialog,
    VFileInput,
    VHover,
    VIcon,
    VImg,
    VList,
    VListItem,
    VListItemTitle,
    VListSubheader,
    VMain,
    VOverlay,
    VProgressCircular,
    VRow,
    VSelect,
    VSnackbar,
    VSlider,
    VTextField,
    VToolbar
} from 'vuetify/components'
import 'vuetify/styles'

const vuetify = createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi
        }
    },
    components: {
        VApp,
        VBtn,
        VCard,
        VCardActions,
        VCardText,
        VCheckbox,
        VCol,
        VContainer,
        VDialog,
        VFileInput,
        VHover,
        VIcon,
        VImg,
        VList,
        VListItem,
        VListItemTitle,
        VListSubheader,
        VMain,
        VOverlay,
        VProgressCircular,
        VRow,
        VSelect,
        VSnackbar,
        VSlider,
        VTextField,
        VToolbar
    }
})

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.mount('#app')